import React, { useState } from "react";
import { FiFilter } from "react-icons/fi";
import { ChevronDown } from "lucide-react";

function AccordionSection({ id, title, isOpen, onToggle, children }) {
  return (
    <div className="filter-accordion-item">
      <button
        type="button"
        className="filter-accordion-header"
        onClick={() => onToggle(id)}
        aria-expanded={isOpen}
      >
        <span>{title}</span>
        <ChevronDown
          size={16}
          className={`filter-accordion-chevron ${isOpen ? "open" : ""}`}
        />
      </button>

      <div className={`filter-accordion-body ${isOpen ? "open" : ""}`}>
        <div className="filter-accordion-body-inner">{children}</div>
      </div>
    </div>
  );
}

function Filtersidebar({
  filterData,
  filters,
  onFilterChange,
  onCheckboxChange,
  priceRange,
  onPriceChange,
  onApply,
}) {
  const [showAllCategories, setShowAllCategories] = useState(false);
  const [showAllBrands, setShowAllBrands] = useState(false);

  const [openSections, setOpenSections] = useState({
    category: false,
    brand: false,
    price: false,
    sort: false,
  });

  const toggleSection = (id) => {
    setOpenSections((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <div className="custom-filter-box">
      {/* <h5 className="filter-title">
        <FiFilter size={18} /> Filters
      </h5> */}

      {/* CATEGORY */}
      <AccordionSection
        id="category"
        title="Category"
        isOpen={openSections.category}
        onToggle={toggleSection}
      >
        {(showAllCategories
          ? filterData?.categories
          : filterData?.categories?.slice(0, 7)
        )?.map((cat) => (
          <div className="custom-checkbox" key={cat._id}>
            <input
              type="checkbox"
              name="category"
              id={`cat-${cat._id}`}
              value={cat._id}
              checked={filters.category.includes(cat._id)}
              onChange={() => onCheckboxChange("category", cat._id)}
            />
            <label htmlFor={`cat-${cat._id}`}>{cat.name}</label>
          </div>
        ))}
        {filterData?.categories?.length > 7 && (
          <p
            className="custom-view-more"
            onClick={() => setShowAllCategories((prev) => !prev)}
          >
            {showAllCategories ? "View Less" : "View More"}
          </p>
        )}
      </AccordionSection>

      {/* BRAND */}
      <AccordionSection
        id="brand"
        title="Brand"
        isOpen={openSections.brand}
        onToggle={toggleSection}
      >
        {(showAllBrands
          ? filterData?.brands
          : filterData?.brands?.slice(0, 7)
        )?.map((b) => (
          <div className="custom-checkbox" key={b.id}>
            <input
              type="checkbox"
              name="brand"
              id={`brand-${b.id}`}
              value={b.id}
              checked={filters.brand.includes(b.id)}
              onChange={() => onCheckboxChange("brand", b.id)}
            />
            <label htmlFor={`brand-${b.id}`}>{b.name}</label>
          </div>
        ))}
        {filterData?.brands?.length > 7 && (
          <p
            className="custom-view-more"
            onClick={() => setShowAllBrands((prev) => !prev)}
          >
            {showAllBrands ? "View Less" : "View More"}
          </p>
        )}
      </AccordionSection>

      {/* PRICE */}
      <AccordionSection
        id="price"
        title="Price"
        isOpen={openSections.price}
        onToggle={toggleSection}
      >
        <div className="range-slider">
          <input
            type="range"
            className="range-input"
            min={filterData?.priceRange?.min || 0}
            max={filterData?.priceRange?.max || 10000}
            value={priceRange[0]}
            onChange={(e) => {
              const val = Math.min(+e.target.value, priceRange[1] - 100);
              onPriceChange([val, priceRange[1]]);
            }}
          />
          <input
            type="range"
            className="range-input"
            min={filterData?.priceRange?.min || 0}
            max={filterData?.priceRange?.max || 10000}
            value={priceRange[1]}
            onChange={(e) => {
              const val = Math.max(+e.target.value, priceRange[0] + 100);
              onPriceChange([priceRange[0], val]);
            }}
          />
          <div
            className="slider-track"
            style={{
              left: `${
                ((priceRange[0] - (filterData?.priceRange?.min || 0)) /
                  ((filterData?.priceRange?.max || 10000) -
                    (filterData?.priceRange?.min || 0))) *
                100
              }%`,
              right: `${
                100 -
                ((priceRange[1] - (filterData?.priceRange?.min || 0)) /
                  ((filterData?.priceRange?.max || 10000) -
                    (filterData?.priceRange?.min || 0))) *
                  100
              }%`,
            }}
          />
        </div>
        <div className="price-values">
          <span>₹{priceRange[0]}</span>
          <span>₹{priceRange[1]}+</span>
        </div>
      </AccordionSection>

      {/* SORT */}
      <AccordionSection
        id="sort"
        title="Sort"
        isOpen={openSections.sort}
        onToggle={toggleSection}
      >
        {filterData?.sorting?.map((opt, i) => (
          <div className="custom-checkbox" key={i}>
            <input
              type="checkbox"
              name="sort"
              id={`sort-${i}`}
              value={opt.value}
              checked={filters.sort === opt.value}
              onChange={(e) => onFilterChange("sort", e.target.value)}
            />
            <label htmlFor={`sort-${i}`}>{opt.label}</label>
          </div>
        ))}
      </AccordionSection>
    </div>
  );
}

export default Filtersidebar;